/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContextMetadata } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * ContextApi - axios parameter creator
 * @export
 */
export const ContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a context file by providing its ID.
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContext: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteContext', 'fileId', fileId)
            const localVarPath = `/api/v1/context/delete-file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download merged content of all contexts
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllContexts: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/context/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a specific `.txt` file by its unique ID. If the file does not exist, a 404 error will be returned.
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFile', 'fileId', fileId)
            const localVarPath = `/api/v1/context/download-file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a list of all uploaded context files. Supports optional keyword search to filter results by filename.
         * @param {string} [keyword] Search keyword
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContextTxt: async (keyword?: string, agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/context/list-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a `.txt` file to be processed and stored. The text content will be converted into vector representations and saved in the database. If a context already exists, it will be updated with the new file.
         * @param {Array<File>} files 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContextTxt: async (files: Array<File>, agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadContextTxt', 'files', files)
            const localVarPath = `/api/v1/context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContextApi - functional programming interface
 * @export
 */
export const ContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContextApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a context file by providing its ID.
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContext(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContext(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.deleteContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download merged content of all contexts
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllContexts(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllContexts(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.downloadAllContexts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a specific `.txt` file by its unique ID. If the file does not exist, a 404 error will be returned.
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.downloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a list of all uploaded context files. Supports optional keyword search to filter results by filename.
         * @param {string} [keyword] Search keyword
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContextTxt(keyword?: string, agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContextTxt(keyword, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.listContextTxt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a `.txt` file to be processed and stored. The text content will be converted into vector representations and saved in the database. If a context already exists, it will be updated with the new file.
         * @param {Array<File>} files 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadContextTxt(files: Array<File>, agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContextMetadata>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadContextTxt(files, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.uploadContextTxt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContextApi - factory interface
 * @export
 */
export const ContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContextApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a context file by providing its ID.
         * @param {ContextApiDeleteContextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContext(requestParameters: ContextApiDeleteContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteContext(requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download merged content of all contexts
         * @param {ContextApiDownloadAllContextsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllContexts(requestParameters: ContextApiDownloadAllContextsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadAllContexts(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a specific `.txt` file by its unique ID. If the file does not exist, a 404 error will be returned.
         * @param {ContextApiDownloadFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(requestParameters: ContextApiDownloadFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFile(requestParameters.fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a list of all uploaded context files. Supports optional keyword search to filter results by filename.
         * @param {ContextApiListContextTxtRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContextTxt(requestParameters: ContextApiListContextTxtRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listContextTxt(requestParameters.keyword, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a `.txt` file to be processed and stored. The text content will be converted into vector representations and saved in the database. If a context already exists, it will be updated with the new file.
         * @param {ContextApiUploadContextTxtRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContextTxt(requestParameters: ContextApiUploadContextTxtRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContextMetadata>> {
            return localVarFp.uploadContextTxt(requestParameters.files, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteContext operation in ContextApi.
 * @export
 * @interface ContextApiDeleteContextRequest
 */
export interface ContextApiDeleteContextRequest {
    /**
     * 
     * @type {string}
     * @memberof ContextApiDeleteContext
     */
    readonly fileId: string
}

/**
 * Request parameters for downloadAllContexts operation in ContextApi.
 * @export
 * @interface ContextApiDownloadAllContextsRequest
 */
export interface ContextApiDownloadAllContextsRequest {
    /**
     * 
     * @type {string}
     * @memberof ContextApiDownloadAllContexts
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for downloadFile operation in ContextApi.
 * @export
 * @interface ContextApiDownloadFileRequest
 */
export interface ContextApiDownloadFileRequest {
    /**
     * 
     * @type {string}
     * @memberof ContextApiDownloadFile
     */
    readonly fileId: string
}

/**
 * Request parameters for listContextTxt operation in ContextApi.
 * @export
 * @interface ContextApiListContextTxtRequest
 */
export interface ContextApiListContextTxtRequest {
    /**
     * Search keyword
     * @type {string}
     * @memberof ContextApiListContextTxt
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof ContextApiListContextTxt
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for uploadContextTxt operation in ContextApi.
 * @export
 * @interface ContextApiUploadContextTxtRequest
 */
export interface ContextApiUploadContextTxtRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof ContextApiUploadContextTxt
     */
    readonly files: Array<File>

    /**
     * 
     * @type {string}
     * @memberof ContextApiUploadContextTxt
     */
    readonly agentId?: string
}

/**
 * ContextApi - object-oriented interface
 * @export
 * @class ContextApi
 * @extends {BaseAPI}
 */
export class ContextApi extends BaseAPI {
    /**
     * 
     * @summary Delete a context file by providing its ID.
     * @param {ContextApiDeleteContextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public deleteContext(requestParameters: ContextApiDeleteContextRequest, options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).deleteContext(requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download merged content of all contexts
     * @param {ContextApiDownloadAllContextsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public downloadAllContexts(requestParameters: ContextApiDownloadAllContextsRequest = {}, options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).downloadAllContexts(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a specific `.txt` file by its unique ID. If the file does not exist, a 404 error will be returned.
     * @param {ContextApiDownloadFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public downloadFile(requestParameters: ContextApiDownloadFileRequest, options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).downloadFile(requestParameters.fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a list of all uploaded context files. Supports optional keyword search to filter results by filename.
     * @param {ContextApiListContextTxtRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public listContextTxt(requestParameters: ContextApiListContextTxtRequest = {}, options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).listContextTxt(requestParameters.keyword, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a `.txt` file to be processed and stored. The text content will be converted into vector representations and saved in the database. If a context already exists, it will be updated with the new file.
     * @param {ContextApiUploadContextTxtRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public uploadContextTxt(requestParameters: ContextApiUploadContextTxtRequest, options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).uploadContextTxt(requestParameters.files, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }
}

